
import { apiUrl } from './../common/constants';
import { getLanguageFromStorage, languageMap, defaultLanguage, i18nProvider } from './../common/language';import { setActivePermissionData, headersAPIObjectAuth } from './../common/utils';
function removeStorage()  {
    
  localStorage.removeItem('auth');
  localStorage.removeItem('email');
  localStorage.removeItem('users_login_id');
  localStorage.removeItem('permissions');
  localStorage.removeItem('active_permission');  
  
  localStorage.removeItem('associations_id');
  localStorage.removeItem('associations_name');  
  localStorage.removeItem('friendly_url'); 
  localStorage.removeItem('permissions_groups');
  localStorage.removeItem('events_id');
  localStorage.removeItem('events_name');
  localStorage.removeItem('members_group_id');
  localStorage.removeItem('members_pending_group_id');
  localStorage.removeItem('associations_logo_doc');
  localStorage.removeItem('subscriptions');
  localStorage.removeItem('language');
  localStorage.removeItem('members_pending_group_id');
  
  
}

// in src/authProvider.js
const authProvider = {
    
  // called when the user attempts to log in
  login: ({ username, password }, translate) =>  {
            
    const request = new Request(apiUrl + '/auth/login', {
      method: 'PUT',
      body: JSON.stringify({ email: username, pswd: password }),
      headers: headersAPIObjectAuth(),
    });

    return fetch(request)
      .then(response => {
        if (response.status === 406)
        {
          throw new Error('ra.auth.auth_account_locked');     
        }
        else if (response.status === 405)
        {
          throw new Error('ra.auth.auth_too_many_attempts'); 
        }
        else if (response.status === 404) {
          throw new Error('ra.auth.auth_invalid_credentials');
        }
        else if (response.status < 200 || response.status >= 300) {
          throw new Error('ra.auth.auth_invalid_credentials');
        }                
        return response.json();
      })
      .then(auth => {
          
        localStorage.setItem('auth', auth.token );
        localStorage.setItem('email', auth.email );
        localStorage.setItem('users_login_id', auth.users_login_id );                    
        localStorage.setItem('permissions', JSON.stringify(auth.permissions) );        
        localStorage.setItem('language', auth.language);
        
        setActivePermissionData(auth.active_permission);
        
        console.log('IDIOMA_CHANGED_BY_AUTH');
        i18nProvider.changeLocale(languageMap[auth.language >= 0 ? auth.language : defaultLanguage]);
        
      })
      .catch((e) => {   
            console.error("Auth error:", e);

            const msg = e?.message ?? e;

            if (msg === "Failed to fetch") {
                throw new Error('ra.auth.error_network');
            }

            throw new Error(msg);            
      });
  },
  // called when the user clicks on the logout button
  logout: () => {
    
    const storedLangId = getLanguageFromStorage();
    
    const request = new Request(apiUrl + '/auth/logout', {
      method: 'DELETE',
      headers: headersAPIObjectAuth()             
    });

    return fetch(request)
    .finally(() => {
      removeStorage();
      window.location.href = `/#/login?lg=${storedLangId}`;
    })
    .then(() => false); 

  },
    
  // called when the API returns an error
  checkError: ({ status }) => {        
    if (status === 401 || status === 403) {
      localStorage.removeItem('auth');
      return Promise.reject();
    }
    return Promise.resolve();
  },
  // called when the user navigates to a new location, to check for authentication
  checkAuth: () => {
    return localStorage.getItem('auth')
      ? Promise.resolve()
      : Promise.reject();
  },
  // called when the user navigates to a new location, to check for permissions / roles
  getPermissions: () => Promise.resolve(),
};


export default authProvider;

